import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Plus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export const CommunitiesSidebar = () => {
  const navigate = useNavigate();
  const [communities, setCommunities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCommunities();
  }, []);

  const fetchCommunities = async () => {
    try {
      const response = await axios.get('/communities');
      // Filter to only show joined communities
      const joinedCommunities = response.data.filter(c => c.is_member);
      setCommunities(joinedCommunities);
    } catch (error) {
      console.error('Failed to fetch communities:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return null;
  }

  return (
    <motion.div
      initial={{ x: -50, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ delay: 0.2 }}
      className="bg-white rounded-lg shadow-sm p-5 border border-cardBorder"
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <MapPin className="w-4 h-4 text-grayMeta" />
          <h3 className="font-baloo font-bold text-base text-primaryDark">My Communities</h3>
        </div>
        <button
          onClick={() => navigate('/communities')}
          className="p-1 hover:bg-surface rounded transition-colors"
          title="Explore all communities"
        >
          <Plus className="w-4 h-4 text-grayMeta" />
        </button>
      </div>

      {communities.length === 0 ? (
        <div className="text-center py-4">
          <p className="text-xs text-grayMeta mb-3">
            Join local communities to discover city-specific ideas
          </p>
          <button
            onClick={() => navigate('/communities')}
            className="text-xs font-semibold text-primary-dark hover:text-primary transition-colors"
          >
            Browse Communities
          </button>
        </div>
      ) : (
        <div className="space-y-2">
          {communities.slice(0, 5).map((community) => (
            <div
              key={community.id}
              onClick={() => navigate(`/communities/${community.id}`)}
              className="flex items-center gap-2 cursor-pointer hover:bg-surface p-2 -mx-2 rounded-lg transition-colors group"
            >
              <div className="w-8 h-8 bg-primary/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <MapPin className="w-4 h-4 text-primary-dark" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-xs text-primaryDark truncate group-hover:text-primary-dark transition-colors">
                  {community.city}
                </div>
                <div className="text-[10px] text-grayMeta truncate">
                  {community.member_count} members
                </div>
              </div>
            </div>
          ))}
          {communities.length > 5 && (
            <button
              onClick={() => navigate('/communities')}
              className="w-full text-xs text-grayMeta hover:text-primary-dark text-center pt-2 border-t border-cardBorder transition-colors"
            >
              +{communities.length - 5} more
            </button>
          )}
        </div>
      )}
    </motion.div>
  );
};
